import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6df90638")

_pushScopeId("data-v-6df90638")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 予約一覧 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("患者の本登録 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("カルテ一覧へ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_patient_time_form = _resolveComponent("patient-time-form")
  const _component_patient_time_table = _resolveComponent("patient-time-table")
  const _component_vue_two_column_content = _resolveComponent("vue-two-column-content")
  const _component_vue_content_remain = _resolveComponent("vue-content-remain")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_vue_button_frame = _resolveComponent("vue-button-frame")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("h2", null, [
            _createVNode(_component_back_button),
            _hoisted_1
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_vue_content_remain, null, {
        default: _withId(() => [
          _createVNode(_component_vue_two_column_content, null, {
            left: _withId(() => [
              _createVNode(_component_patient_time_form)
            ]),
            right: _withId(() => [
              _createVNode(_component_patient_time_table)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_vue_button_frame, null, {
        left: _withId(() => []),
        right: _withId(() => [
          (_ctx.selectedTemporaryPatient !== undefined)
            ? (_openBlock(), _createBlock(_component_normal_button, {
                key: 0,
                class: "vue-button-frame-button",
                state: "warning",
                onClick: _ctx.onUpdateTemporaryPatient
              }, {
                default: _withId(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["onClick"]))
            : (_openBlock(), _createBlock(_component_normal_button, {
                key: 1,
                class: "vue-button-frame-button",
                state: "warning",
                disabled: _ctx.selectedPatient === undefined,
                onClick: _ctx.onKarte
              }, {
                default: _withId(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})